"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _overrides = require("../../../utils/overrides");

var _styles = require("../../../utils/styles");

var _styles2 = _interopRequireDefault(require("./styles"));

var useStyles = (0, _styles.createUseStyles)(_styles2.default, 'Loader');

function Loader(_ref) {
  var classesProp = _ref.classes,
      className = _ref.className,
      size = _ref.size,
      color = _ref.color;
  var classes = (0, _overrides.useClasses)(useStyles, classesProp);
  var rootClassName = (0, _classnames.default)(className, classes.root, [classes[color]], [classes[size]]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: rootClassName
  });
}

Loader.defaultProps = {
  size: 'medium',
  color: 'primary'
};
process.env.NODE_ENV !== "production" ? Loader.propTypes = {
  className: _propTypes.default.string,
  size: _propTypes.default.oneOf(['mini', 'tiny', 'small', 'medium', 'large', 'big', 'huge', 'massive']),
  color: _propTypes.default.oneOf(['primary', 'danger', 'white'])
} : void 0;

var _default = /*#__PURE__*/_react.default.memo(Loader);

exports.default = _default;